import React from "react";
import Hero from "./Hero";
import AppelAction from "../../components/AppelAction";
import SEOHead from "../../components/SEOHead";
import { usePageSEO } from "../../utils/seoUtils";

const Actualites = () => {
    const seoData = usePageSEO('/actualites');
    
    return (
        <>
            <SEOHead {...seoData} />
            <Hero />
            <AppelAction className="section-border-top" />
        </>
    );
};

export default Actualites;
